import React from 'react'
import styled from '@emotion/styled'
import { array, string } from 'prop-types'

// Import Components
import { makeImgResizerUrl, replaceSpacesWithDashes } from '@jelly/utils'
import { AnchorTag, Chevron, ContentContainer, MonetizationButton } from '@jelly/components'
import { Link } from '@jelly/ui'

// Styled Components via Emotion
const ReviewsContainer = styled.div`
	width: 100%;
`
const ReviewCardsContainer = styled.div`
	overflow-x: auto;
	white-space: nowrap;
	width: 100%;

	::-webkit-scrollbar {
		-webkit-overflow-scrolling: auto;
		-webkit-appearance: none;
		height: 8px;
	}
	::-webkit-scrollbar-thumb {
		border-radius: 10px;
		background-color: rgba(0, 0, 0, 0.4);
	}
`
const ReviewsScrollContainer = styled.div`
	margin-top: 16px;
	width: 100%;
`
const ServiceCard = styled.div`
	box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.16);
	display: inline-flex;
	flex-direction: column;
	height: 320px;
	justify-content: space-between;
	margin: 5px;
	padding: 15px;
	width: 200px;
`
const ServiceName = styled.div`
	color: ${({ theme }) => theme.colors.text};
	border-bottom: 1px solid #ccc;
	font-size: 18px;
	height: 80px;
	white-space: normal;
`
const Thumbnail = styled.img`
	display: block;
	height: auto;
	margin: 20px auto;
	max-width: 100px;
	width: auto;
`
const LinksWrapper = styled.div`
	.monetization-button {
		letter-spacing: normal;
		padding: 10px 0;
	}
`
const VisitSite = styled(Link)`
	color: ${({ theme }) => theme.colors.contentLink};
	cursor: pointer;
	display: block;
`
const ChevronWrapper = styled.div`
	display: inline-block;
	height: 12px;
	margin-left: 5px;
	transform: rotate(90deg);
	vertical-align: middle;
	width: 12px;

	polyline {
		stroke: ${({ theme }) => theme.colors.contentLink};
	}
`

Reviews.propTypes = {
	categoryWidgetId: string,
	intro: string,
	reviews: array.isRequired,
	servicesData: array.isRequired,
}

export function Reviews({ categoryWidgetId, intro, reviews }) {
	return (
		<ReviewsContainer>
			<ContentContainer content={intro} />
			<ReviewCardsContainer>
				<ReviewsScrollContainer>
					{reviews &&
						reviews.map((reviewData, i) => {
							if (!reviewData.review) {
								return false
							}
							const serviceName = replaceSpacesWithDashes(reviewData.review.title)
							return (
								<ServiceCard key={i}>
									<AnchorTag
										href={reviewData.canonical}
										id={`category_${serviceName}_reviews_readreview`}
									>
										<ServiceName>{reviewData.review.title}</ServiceName>
									</AnchorTag>
									<AnchorTag
										href={reviewData.canonical}
										id={`category_${serviceName}_reviews_readreview`}
									>
										<Thumbnail
											className="lazyload"
											alt={reviewData.serviceName}
											data-src={makeImgResizerUrl({
												src: reviewData.thumbnail?.path,
												method: 'w',
												w: 150,
											})}
										/>
									</AnchorTag>
									<LinksWrapper>
										<VisitSite
											id={`category_${serviceName}_reviews_readmore`}
											href={reviewData.canonical}
										>
											Read More
											<ChevronWrapper>
												<Chevron />
											</ChevronWrapper>
										</VisitSite>

										<MonetizationButton
											categoryWidgetId={categoryWidgetId}
											pricing={reviewData.pricing}
											rank={i}
											serviceName={serviceName}
											sectionType="reviews"
											tabTitle="undefined"
											templateType="category"
											type="review"
										/>
									</LinksWrapper>
								</ServiceCard>
							)
						})}
				</ReviewsScrollContainer>
			</ReviewCardsContainer>
		</ReviewsContainer>
	)
}
